module.exports = __webpack_public_path__ + "img/houdini_logo.e1ee53fa.png";